import React from "react"

import Layout from "../../components/layout"
import Seo from "../../components/seo"
import HeroPagesCenter from "../../components/heroes/hero-pages-center"
import DemoData from "../../content/demo/index.json"
import { Container, Row, Col } from 'react-bootstrap'
import { injectIntl } from "gatsby-plugin-react-intl"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import ImageFluid from "../../components/misc/image-fluid";
import TrialRequestDemoForm from "../../components/forms/trial-request-demo-form"

const DemoIndexPage = ({ intl, location }) => (
    <Layout>
        <Seo lang={intl.locale} title={DemoData[intl.locale].title} description={DemoData[intl.locale].text} pathname={location.pathname} />
        <HeroPagesCenter theme={`primary`} content={DemoData[intl.locale]} />
        <div className={`demo`}>
            <Container>
                <Row noGutters={true}>
                    <Col md={4}>
                        <div className={`top-small-overflow-wrapper`}>
                            <div className={`demo-content`}>
                                <div className={`title`}>{DemoData[intl.locale].content.title}</div>
                                <div className={`reasons`}>
                                    {DemoData[intl.locale].content.reasons.map((reason, i) => {
                                        return (
                                            <div key={i} className={`reason`}>
                                                <FontAwesomeIcon icon="arrow-right" />
                                                {reason.text}
                                            </div>
                                        )
                                    })}
                                </div>
                                <div className={`image`}><ImageFluid alt={``} filename={DemoData[intl.locale].content.image} /></div>
                            </div>
                        </div>
                    </Col>
                    <Col md={8}>
                        <div className={`top-overflow-wrapper`}>
                            <TrialRequestDemoForm />
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    </Layout>
)

export default injectIntl(DemoIndexPage)
